import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ProSelectField from "../../Components/Inputs/SelectField";
import DateField from "../../Components/Inputs/DateField";
import { useForm } from "react-hook-form";
import {
  ADD_JOURNEY_WORKER_CERTIFICATION,
  GET_ALL_PROJECT,
  GET_ALL_PARTNERS_DROPDOWN,
  ACTIVE_MENTORS_BY_PROJECT_AND_PARTER
} from "../../../utils/services/apiPath";
import { getApi, postApi } from "../../../utils/services";
import { convertFileToBase64Model, prepareDefaultValues, prepareInitialConfig } from "../../../utils/formHelper";
import { Box, Button, Grid, IconButton, Modal, Typography } from "@mui/material";
import { Close, FileUpload } from "@mui/icons-material";
import fileUpload from "../../Assets/Icons/FileUpload.png";
import ProButton from "../ProButton";
import FileUploadBox from "./FileUploadBox";

const uploadPopupContainer = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4
};

const journeyWorkerCertificationFields = {
  projectId: {
    label: "Project Name",
    perKey: "Project",
    placeholder: "Select Project",
    rules: { required: "Project Name is Required!" }
  },
  partnerId: {
    label: "Partner Name",
    perKey: "Partner",
    placeholder: "Select Partners",
    rules: { required: "Partner Name is Required!" }
  },
  employeeId: {
    label: "Employee Name",
    perKey: "Employee",
    placeholder: "Select Employee",
    rules: { required: "Employee Name is Required!" }
  }
};

export default function UploadFileJourneyWorkerCert({ title, getDetailData, fetchInsightData }) {
  const [formConfig] = useState(prepareInitialConfig(journeyWorkerCertificationFields, "edit"));
  const { handleSubmit, control, watch } = useForm({ defaultValues: prepareDefaultValues(journeyWorkerCertificationFields) });
  const [projectsList, setProjectsList] = useState([]);
  const [mentorList, setMentorList] = useState([]);
  const [partnersList, setPartnersList] = useState([]);
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const project = watch("projectId");
  const partner = watch("partnerId");
  const employee = watch("employeeId");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileSelect = selectedFile => {
    setErrorMessage("");
    setFile(selectedFile);
  };

  const fetchProjects = async () => {
    const { data } = await getApi(GET_ALL_PROJECT);
    setProjectsList(data?.filter(item => item.projectId !== "All").map(item => ({ label: item.projectName, value: item.projectId })));
  };

  const fetchPartners = async () => {
    const { data } = await getApi(`${GET_ALL_PARTNERS_DROPDOWN}?projectId=${project}`);
    if (data) {
      setPartnersList(data?.filter(item => item.clientGuid !== "All").map(item => ({ label: item.companyName, value: item.clientGuid })));
    }
  };

  const fetchMentors = async () => {
    const res = await getApi(`${ACTIVE_MENTORS_BY_PROJECT_AND_PARTER}?projectId=${project}&partnerId=${partner}`);
    setMentorList(
      Object.keys(res ?? {})
        .filter(key => key !== "all")
        .map(key => ({ label: res[key], value: key }))
    );
  };

  useEffect(() => {
    const preventDefault = e => {
      e.preventDefault();
    };

    window.addEventListener("dragover", preventDefault);
    window.addEventListener("drop", preventDefault);

    return () => {
      window.removeEventListener("dragover", preventDefault);
      window.removeEventListener("drop", preventDefault);
    };
  }, []);

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (project) {
      fetchPartners();
    }
  }, [project]);

  useEffect(() => {
    if (partner) {
      fetchMentors();
    }
  }, [partner]);

  const defaultFormProps = { control };
  const handleSave = async () => {
    if (!file) {
      setErrorMessage("Journey Worker Certification is Required!");
      return;
    }
    const payload = {
      projectId: project,
      employeeId: employee,
      partnerId: partner,
      documentMediaModel: await convertFileToBase64Model(file)
    };
    const res = await postApi(ADD_JOURNEY_WORKER_CERTIFICATION, payload);
    getDetailData();
    fetchInsightData();
    handleClose();
  };
  return (
    <>
      <Button id="upload-files" variant="outlined" size="small" sx={{ width: "150px" }} onClick={handleOpen}>
        Upload
        <FileUpload />
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={uploadPopupContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
              <IconButton aria-label="close" onClick={handleClose} sx={{ position: "absolute", right: 16, top: 16 }}>
                <Close />
              </IconButton>
            </Grid>
            <ProSelectField
              {...defaultFormProps}
              {...formConfig.projectId}
              options={projectsList}
              permission={{ canView: true, canAdd: true, canEdit: true }}
            />
            <ProSelectField
              {...defaultFormProps}
              {...formConfig.partnerId}
              options={partnersList}
              permission={{ canView: true, canAdd: true, canEdit: true }}
            />
            <ProSelectField
              {...defaultFormProps}
              {...formConfig.employeeId}
              options={mentorList}
              permission={{ canView: true, canAdd: true, canEdit: true }}
            />
            <Grid item xs={12}>
              <FileUploadBox onFileSelect={handleFileSelect} fileUpload={fileUpload} file={file} errorMessage={errorMessage} />
            </Grid>

            <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: "16px" }}>
              <ProButton variant="outlined" color="secondary" onClick={handleClose}>
                {"Cancel"}
              </ProButton>
              <ProButton onClick={handleSubmit(handleSave)}>{"Save"}</ProButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

UploadFileJourneyWorkerCert.propTypes = {
  title: PropTypes.string,
  getDetailData: PropTypes.func,
  fetchInsightData: PropTypes.func
};